(function () {

  const TALLAS = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '3xl', '4xl', '5xl'];
  const DISEÑOS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

  const NOMBRES_ADDON = {
    'dtf_5x5': 'DTF 5×5 cm',         'dti_5x5': 'DTI 5×5 cm',
    'dtf_10x5': 'DTF 10×5 cm',       'dti_10x5': 'DTI 10×5 cm',
    'dtf_10x10': 'DTF 10×10 cm',     'dti_10x10': 'DTI 10×10 cm',
    'dtf_14x10': 'DTF 14×10 cm',     'dti_14x10': 'DTI 14×10 cm',
    'dtf_20x14': 'DTF 20×14 cm',     'dti_20x14': 'DTI 20×14 cm',
    'dtf_27x20': 'DTF 27×20 cm',     'dti_27x20': 'DTI 27×20 cm',
    'dtf_40x27': 'DTF 40×27 cm',     'dti_40x27': 'DTI 40×27 cm',
    'serigrafia_a4_1c': 'Serigrafía A4 — 1 color',
    'serigrafia_a3_1c': 'Serigrafía A3 — 1 color',
    'serigrafia_a4_2c': 'Serigrafía A4 — 2 colores',
    'serigrafia_a3_2c': 'Serigrafía A3 — 2 colores',
    'serigrafia_puff_a4_1c': 'Serigrafía Puff A4 — 1 color',
    'serigrafia_puff_a3_1c': 'Serigrafía Puff A3 — 1 color',
    'serigrafia_puff_a4_2c': 'Serigrafía Puff A4 — 2 colores',
    'serigrafia_puff_a3_2c': 'Serigrafía Puff A3 — 2 colores',
    'bordado_3x3': 'Bordado 3×3 cm',
    'bordado_5x5': 'Bordado 5×5 cm',
    'bordado_7x7': 'Bordado 7×7 cm',
    'bordado_10x10': 'Bordado 10×10 cm',
    'bordado_15x15': 'Bordado 15×15 cm',
    'bordado_25x25': 'Bordado 25×25 cm',
    'bordado_27x27': 'Bordado 27×27 cm',
    'parche_5x5': 'Parche 5×5 cm',
    'parche_5x10': 'Parche 5×10 cm',
    'parche_10x10': 'Parche 10×10 cm',
    'parche_10x15': 'Parche 10×15 cm',
    'parche_15x15': 'Parche 15×15 cm',
    'parche_13x20': 'Parche 13,5×20 cm',
    'parche_20x20': 'Parche 20×20 cm',
    'parche_20x30': 'Parche 20×30 cm',
    'parche_23x35': 'Parche 23,5×35 cm',
    'parche_30x30': 'Parche 30×30 cm',
    'parche_35x35': 'Parche 35×35 cm',
    'parche_40x40': 'Parche 40×40 cm',
    'dtg_10x10': 'DTG 10×10 cm',
    'dtg_15x20': 'DTG 15×20 cm',
    'dtg_30x30': 'DTG 30×30 cm',
    'dtg_34x49': 'DTG 34,5×49 cm',
  };

  function getTotalUnidades() {
    return TALLAS.reduce((total, talla) => {
      const input = document.querySelector(`[name="properties[_${talla}_x]"]`);
      return total + (parseInt(input?.value) || 0);
    }, 0);
  }

  function getTecnicasSeleccionadas() {
    const tecnicas = [];
    DISEÑOS.forEach(num => {
      const selectores = [
        `select[name="properties[tamaño_dti_${num}]"]`,
        `select[name="properties[tamaño_dtf_${num}]"]`,
        `select[name="properties[tamaño_serigrafia_${num}]"]`,
        `select[name="properties[tamaño_serigrafia_puff_${num}]"]`,
        `select[name="properties[tamaño_bordado_${num}]"]`,
        `select[name="properties[tamaño_parches_${num}]"]`,
        `select[name="properties[tamaño_dtg_${num}]"]`,
      ];

      for (const selector of selectores) {
        const el = document.querySelector(selector);
        if (el && el.value) {
          tecnicas.push(NOMBRES_ADDON[el.value] || el.value);
          break;
        }
      }
    });
    return tecnicas;
  }

  function getServiciosAdicionales() {
    const servicios = [];
    
    // Verificar si el checkbox de DOBLADO está marcado
    const dobladoCheckbox = document.querySelector('.cl-po--option[data-option="doblado"] input[type="checkbox"]');
    if (dobladoCheckbox && dobladoCheckbox.checked) {
      servicios.push('Doblado');
    }
    
    // Verificar si el checkbox de EMBOLSADO está marcado
    const embolsadoCheckbox = document.querySelector('.cl-po--option[data-option="embolsado"] input[type="checkbox"]');
    if (embolsadoCheckbox && embolsadoCheckbox.checked) {
      servicios.push('Embolsado');
    }
    
    return servicios;
  }

  function actualizarResumen() {
    const resumenEl = document.querySelector('.cl-po--price-summary');
    if (!resumenEl) return;

    const previo = resumenEl.querySelector('.tgd-resumen');
    if (previo) previo.remove();

    const total = getTotalUnidades();
    if (total === 0) return;

    const tecnicas = getTecnicasSeleccionadas();
    const servicios = getServiciosAdicionales();

    // Obtener el precio total de LPO
    const precioTotalEl = resumenEl.querySelector('.cl-po--price-summary-value');
    const precioTotal = precioTotalEl ? parseFloat(precioTotalEl.textContent.replace(/[^\d,]/g, '').replace(',', '.')) : 0;

    const precioPorPrenda = precioTotal / total;

    // TGD — Sincronizar precios con el footer del modal

    const formatoPrecioModal = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    const modalUnitPrice = document.querySelector(
      '[data-tgd-customizer-unit-price]'
    );

    const modalQuantity = document.querySelector(
      '[data-tgd-customizer-quantity]'
    );

    const modalTotalPrice = document.querySelector(
      '[data-tgd-customizer-total-price]'
    );

    if (modalUnitPrice) {
      modalUnitPrice.textContent = precioTotal > 0
        ? formatoPrecioModal.format(precioPorPrenda)
        : '—';
    }

    if (modalQuantity) {
      modalQuantity.textContent = total;
    }

    if (modalTotalPrice) {
      modalTotalPrice.textContent = precioTotal > 0
        ? formatoPrecioModal.format(precioTotal)
        : '—';
    }



    let html = `<div class="tgd-resumen-separador"></div>`;

    // Línea producto base
    html += `
      <div class="tgd-resumen-linea">
        <span>Producto base</span>
        <span>${total} uds</span>
      </div>`;

    // Líneas técnicas
    tecnicas.forEach(nombre => {
      html += `
        <div class="tgd-resumen-linea">
          <span>${nombre}</span>
          <span>${total} uds</span>
        </div>`;
    });

    // Servicios adicionales (doblado y embolsado)
    servicios.forEach(nombre => {
      html += `
        <div class="tgd-resumen-linea">
          <span>${nombre}</span>
          <span>${total} uds</span>
        </div>`;
    });

    // Línea divisoria antes del precio por prenda
    html += `<div class="tgd-resumen-separador"></div>`;

    // Precio por prenda AL FINAL
    if (precioTotal > 0) {
      html += `
        <div class="tgd-precio-por-prenda">
          <span class="tgd-label-unitario">Precio por prenda</span>
          <span class="tgd-precio-unitario">${precioPorPrenda.toFixed(2).replace('.', ',')}€</span>
        </div>`;
    }

    const div = document.createElement('div');
    div.className = 'tgd-resumen';
    div.innerHTML = html;
    resumenEl.appendChild(div);
  }

  const observer = new MutationObserver(() => {
    actualizarResumen();
  });

  function init() {
    const summary = document.querySelector('.cl-po--price-summary');
    if (summary) {
      observer.observe(summary, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('input', actualizarResumen);
    document.addEventListener('change', actualizarResumen);
    setTimeout(actualizarResumen, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// Forzar cantidad de Shopify a 1 para permitir añadir al carrito
document.addEventListener('DOMContentLoaded', () => {
  const qtyInput = document.querySelector('input[name="quantity"]');
  if (qtyInput) {
    qtyInput.value = '1';
    qtyInput.setAttribute('value', '1');
  }
});